var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnywhere(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "192px",
    height: "192px",
    viewBox: "0 0 192 192",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Other/logo/colored/Anywhere") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Other/logo/colored/Anywhere",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "area",
    x: 0,
    y: 0,
    width: 192,
    height: 192
  }), /*#__PURE__*/React.createElement("g", {
    id: "Logo",
    transform: "translate(28.000000, 36.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.535117,110 L136,110 L102.797085,18 L89.2024122,18 L56,110 L69.333283,110 L78.483528,83.5467578 L113.25468,83.5467578 L122.535117,110 Z M96.1305439,30.6402735 C96.1305439,30.6402735 98.0912675,38.9802302 99.6599068,43.671412 L109.856012,72.8612103 L81.8821961,72.8612103 L92.208996,43.671412 C93.7775346,38.9802302 95.8690537,30.6402735 95.8690537,30.6402735 L96.1305439,30.6402735 Z",
    id: "Shape",
    fill: "#222222",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#008ACE",
    points: "46.6987128 0.000238361444 37 0 0 120 9.44887326 120 19 120 56 0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnywhere);
export default __webpack_public_path__ + "642ea7614030ecac5a666c774c1e0cc4.svg";
export { ForwardRef as ReactComponent };